export default function transformImage(url: string, transformations: string) {
  return url.replace('upload', 'upload/' + transformations);
}
